import styled, { css } from "styled-components/macro";
import { breakpoint, space } from "shared/styles/constants";

interface ISpacerStyles {
  spaceDirection?: "horizontal" | "vertical";
  align?: "flex-start" | "center" | "flex-end" | "stretch";
  justifyContent?: "flex-start" | "center" | "flex-end" | "stretch" | "space-between";
  size: keyof typeof space;
  flexDirection?: "row-reverse" | "column-reverse";
  flexWrap?: "wrap" | "nowrap";
}
export interface StyledSpacerProps extends ISpacerStyles {
  mobile?: Partial<ISpacerStyles>;
}

const resetMargins = css`
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
`;

const getSpaceMargin = ({ spaceDirection, flexDirection, size }: ISpacerStyles) => {
  let marginStyles;
  if (flexDirection === "column-reverse") {
    marginStyles = css`
      ${resetMargins}
      margin-bottom: ${space[size]} !important;
    `;
  } else if (flexDirection === "row-reverse") {
    marginStyles = css`
      ${resetMargins}
      margin-right: ${space[size]} !important;
    `;
  } else if (spaceDirection === "vertical") {
    marginStyles = css`
      ${resetMargins}
      margin-top: ${space[size]} !important;
    `;
  } else {
    marginStyles = css`
      ${resetMargins}
      margin-left: ${space[size]} !important;
    `;
  }
  return css`
    > * + * {
      ${marginStyles}
    }
  `;
};

const getMobileStyles = ({
  spaceDirection,
  align,
  justifyContent,
  flexWrap,
  flexDirection,
  size,
}: Partial<ISpacerStyles>) => css`
  ${(spaceDirection || flexDirection) &&
  css`
    flex-direction: ${flexDirection || (spaceDirection === "vertical" ? "column" : "row")};
  `}
  ${align &&
  css`
    align-items: ${align};
  `}
      ${justifyContent &&
  css`
    justify-content: ${justifyContent};
  `}
      ${flexWrap &&
  css`
    flex-wrap: ${flexWrap};
  `}

  ${size && getSpaceMargin({ size, spaceDirection, flexDirection })}
`;

export const StyledSpacer = styled.div<StyledSpacerProps>`
  display: flex;
  flex-direction: ${({ spaceDirection, flexDirection }) =>
    flexDirection || (spaceDirection === "vertical" ? "column" : "row")};
  align-items: ${({ align }) => align};
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-wrap: ${({ flexWrap }) => flexWrap};

  max-width: 100%;

  > * {
    flex: 0 1 auto;
  }

  ${getSpaceMargin}

  ${({ mobile }) =>
    mobile &&
    css`
      ${breakpoint("l", "down")} {
        ${getMobileStyles(mobile)}
      }
    `}
`;
